import { ReactNode } from "react";
import { FieldWarningIndicator } from "routes/Customer/Waste/Manifests/FieldWarningIndicator";
import { SourcesDisagreeTooltip } from "routes/Customer/Waste/Manifests/SourcesDisagreeTooltip";

import type { ReviewFieldDiff } from "./reviewFieldDiffs";

/**
 * In-input end adornment for a review field whose sources disagree: the shared
 * warning icon + hover tooltip. Rendered as a field `endAdornment` (inside the
 * input) rather than beside it, so it never reflows the surrounding row or
 * steals width from narrow fields (e.g. the state picker) and coexists cleanly
 * with a validation error's helperText. Returns `undefined` when there is no
 * diff, so callers can pass the result straight through as `endAdornment`.
 */
export function reviewDiffAdornment(diff: ReviewFieldDiff | undefined): ReactNode {
  if (!diff) return undefined;
  return (
    <FieldWarningIndicator
      tooltip={<SourcesDisagreeTooltip values={diff.values} />}
      ariaLabel="Sources disagree on this value"
      interactive
    />
  );
}
